
(function () {
  initializeUtilsFunctions();
  executeOnce('news-page', function () {
    const newsCustomTextButton = document.querySelectorAll(".custom-news-button");
    if (newsCustomTextButton.length > 0){
      newsCustomTextButton.forEach((buttonParent) => {
        const link = buttonParent.querySelector(".news-link");
        if (link){
          link.classList.add("btn", "btn--md", "btn--purple", "find-price-btn", "btn--shadow", "btn--uppercase");
        }
      })
    }

    [...document.querySelectorAll('.news-page iframe')].forEach(item => {
      const height = item.offsetHeight;
      const ratio = (16 / 9);
      item.setAttribute('width', height * ratio);
      item.style.display = "block";
      item.style.margin = "0 auto";
    });

    window.addEventListener("load", ()=>{
      const newsIndex = document.querySelector(".index-container");
      if (newsIndex){
        [...newsIndex.querySelectorAll(".link-paragraph")].forEach((link) => {
          link.addEventListener("click",(e)=>{
            e.preventDefault();
            const bookmark = link.getAttribute("href");
            if (bookmark){
              const target = document.querySelector(bookmark);
              target.scrollIntoView({
                behavior: 'smooth'
              });
              history.pushState(null,null,bookmark);
            }
          })
        })
      }
    });
  });
}())
